/**
 * 技术特征颜色映射,字体为白色时候的背景颜色
 */
export const TECHNICAL_FEATURE_COLOR_ARR = [
    '#B5DAA6',
    '#82C3FF',
    '#82D7E4',
    '#F1CB9C',
    '#D4B9EB',
    '#EDA3AD',
];

/**
 * 技术特征颜色映射,字体为黑色时候的背景颜色
 */
export const TECHNICAL_FEATURE_BG_COLOR_ARR = [
    '#E3F1DE',
    '#DDEBF8',
    '#D4F0F6',
    '#FAECDA',
    '#E2D5ED',
    '#F8DDE0',
];

/**
 * 技术特征字母
 */
export const TECHNICAL_FEATURE_LETTERS = 'abcdefghijklmnopqrstuvwxyz';

/**
 * 技术特征编辑器最大字数
 */
export const TECHNICAL_FEATURE_MAX_TEXT_LENGTH = 1000;

/**
 * FTO报告输入框输入最大字数
 */
export const NOVELTY_CHECK_INPUT_MAX_LENGTH = 5000;

/**
 * FTO报告触发要点总结的字符阈值（2000 字符）
 */
export const NOVELTY_CHECK_TRIGGER_POINT_SUMMARY_MIN_LENGTH = 1000;

/**
 * FTO报告输入框输入最小字数
 */
export const NOVELTY_CHECK_INPUT_MIN_LENGTH = 50;

/**
 * 检索策略名称
 */
export enum RETRIEVAL_STRATEGY {
    /**
     * 语义检索
     */
    SEMANTIC_SEARCH = 'semantic_search',
    /**
     * 分类号检索
     */
    IPC_CPC_SEARCH = 'ipc_cpc_search',
    /**
     * 第 1 次块检索
     */
    BLOCK_PROGRESSIVE_SEARCH_1 = 'block_progressive_search_1',
    /**
     * 第 2 次块检索
     */
    BLOCK_PROGRESSIVE_SEARCH_2 = 'block_progressive_search_2',
    /**
     * 第 3 次块检索
     */
    BLOCK_PROGRESSIVE_SEARCH_3 = 'block_progressive_search_3',
    /**
     * 第 4 次块检索
     */
    BLOCK_PROGRESSIVE_SEARCH_4 = 'block_progressive_search_4',
    /**
     * 相关跟踪检索
     */
    RELEVANT_TRACKING_SEARCH = 'relevant_tracking_search',
}

/**
 * 输入的语言不符合要求错误
 */
export const ERROR_INPUT_LANGUAGE_NOT_SATISFIED = 'INPUT_LANGUAGE_NOT_SATISFIED';

/**
 * 输入过长错误
 */
export const ERROR_INPUT_TOO_LONG = 33120013;

/**
 * 人工每篇专利检索+对比耗时：5 + 5，单位：秒
 */
export const HUMAN_RETRIEVAL_PER_PATENT_TIME = 5 * 60 + 5 * 60;

/**
 * 技术特征对比最大选择数量
 */
export const TECHNICAL_FEATURE_COMPARE_MAX_SELECTED_COUNT = 5;

/**
 * FTO报告专利对比最大选择数量
 */
export const FTO_PATENT_COMPARE_MAX_SELECTED_COUNT = 10;

/**
 * FTO支持的输入语言
 */
export const SupportedLanguages = ['cn', 'en'];

/**
 * 输入需要总结错误
 */
export const ERROR_INPUT_NEED_SUMMARY = 'ERROR_INPUT_NEED_SUMMARY';

/**
 * 查新报告路由名称
 */
export const FTO_REPORT_ROUTER_NAME= 'fto-report';

/**
 * 技术特征输入框最大字数
 */
export const FTO_TECHNICAL_FEATURE_INPUT_MAX_LENGTH = 200;
